import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { Location, Shift } from 'features/notifications/types';

import {
  convertToTimezone,
  displayFullTimeRange,
  displayMonthDay,
  displayShortMonth,
  displayShortWeekday,
} from 'util/dateTime';

type ShiftCardProps = {
  shift: Shift;
  location: Location;
  name?: string;
};

const ShiftCard = ({ shift, location, name }: ShiftCardProps) => {
  const { start_at_secs, end_at_secs, role_name } = shift;
  const { name: location_name, tz_name: locationTzName } = location;

  const startInTz = convertToTimezone(start_at_secs, locationTzName);
  const endInTz = convertToTimezone(end_at_secs, locationTzName);

  return (
    <Box row gap={8} p={16} ph={32} alignItemsCenter>
      <Box bradiuss bw={1} bcolor="mono300" bgcolor="mono100" p={8} ph={18}>
        <Text variant="captionBold" textAlign="center">
          {displayShortWeekday(startInTz)}
        </Text>
        <Text variant="heading3" color="mono900" textAlign="center">
          {displayMonthDay(startInTz)}
        </Text>
        <Text variant="captionBold" textAlign="center">
          {displayShortMonth(startInTz)}
        </Text>
      </Box>
      <Box>
        <Text variant="bodyBoldTight">{name || 'Open Shift'}</Text>
        <Box row gap={4} alignItemsCenter>
          <Text variant="bodySm" color="mono700">
            {displayFullTimeRange(startInTz, endInTz)}
          </Text>
          {role_name && (
            <>
              <Text variant="bodySm" color="mono700">
                •
              </Text>
              <Text variant="bodySm" color="mono700">
                {role_name}
              </Text>
            </>
          )}
        </Box>
        <Text variant="bodySm">{location_name}</Text>
      </Box>
    </Box>
  );
};

export default ShiftCard;
